import { Link } from 'react-router-dom';

export type Crumb = {
  name: string;
  to?: string;
};

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full border-b border-background-200 bg-background-100/60">
      <div className="w-full px-4 md:px-8 py-3">
        <ol className="flex items-center gap-2 flex-wrap text-xs md:text-sm font-label text-foreground-500">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={item.name} className="flex items-center gap-2">
                {item.to && !isLast ? (
                  <>
                    <Link to={item.to} className="hover:text-primary-700 transition-colors">
                      {item.name}
                    </Link>
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </>
                ) : (
                  <span className={isLast ? 'text-foreground-800' : ''} aria-current={isLast ? 'page' : undefined}>
                    {item.name}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}